import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { hdr } from '../../pages/PlanningRessourcesPage';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export const NouveauChantierDialog = ({ ressources, onClose, onCree }) => {
  const [f, setF] = useState({ titre: '', societe_id: (ressources.societes[localStorage.getItem('societeId')] && localStorage.getItem('societeId')) || Object.keys(ressources.societes)[0] || '', client_nom: '', lieu: '', date_debut: '', nb_jours: 1, condition_meteo: '' });
  const [choisies, setChoisies] = useState([]);
  const [q, setQ] = useState('');
  const toutes = [...ressources.materiels.map((m) => ({ type: 'materiel', id: m.id, nom: m.nom })), ...ressources.personnes.map((p) => ({ type: 'personne', id: p.id, nom: p.nom }))];
  const proposees = q.length > 1 ? toutes.filter((r) => r.nom.toLowerCase().includes(q.toLowerCase()) && !choisies.some((c) => c.id === r.id)).slice(0, 8) : [];
  const creer = async () => {
    const body = { ...f, nb_jours: Number(f.nb_jours), date_debut: f.date_debut || null, statut: f.condition_meteo ? 'attente_meteo' : 'planifie', ressources: choisies };
    const r = await fetch(`${API}/api/planning-ressources/chantiers`, { method: 'POST', headers: hdr(), body: JSON.stringify(body) });
    if (r.ok) onCree(); else toast.error("Le chantier n'a pas pu être ajouté.");
  };
  const champ = (k, label, type = 'text') => (
    <div><label className="text-xs text-stone-500">{label}</label><Input data-testid={`nouveau-${k}`} type={type} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} /></div>
  );
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="nouveau-chantier-dialog" className="max-w-lg">
        <DialogHeader><DialogTitle>Nouveau chantier</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {champ('titre', 'Chantier')}
          <div><label className="text-xs text-stone-500">Société</label>
            <select data-testid="nouveau-societe" className="w-full border rounded-md h-9 px-2 text-sm" value={f.societe_id} onChange={(e) => setF({ ...f, societe_id: e.target.value })}>
              {Object.entries(ressources.societes).map(([id, nom]) => <option key={id} value={id}>{nom}</option>)}</select></div>
          <div className="grid grid-cols-2 gap-2">{champ('client_nom', 'Client')}{champ('lieu', 'Lieu / parcelle')}{champ('date_debut', 'Début', 'date')}{champ('nb_jours', 'Jours', 'number')}</div>
          {champ('condition_meteo', 'Condition météo (laisser vide si aucune)')}
          <div><label className="text-xs text-stone-500">Machines et personnes</label>
            <Input data-testid="nouveau-ressource-recherche" placeholder="Fendt, Antonin…" value={q} onChange={(e) => setQ(e.target.value)} />
            {proposees.map((r) => <button key={r.id} data-testid={`proposee-${r.id}`} className="block text-sm py-1 hover:text-emerald-700" onClick={() => { setChoisies([...choisies, r]); setQ(''); }}>+ {r.nom}</button>)}
            <div className="flex flex-wrap gap-1 mt-2">{choisies.map((r) => <span key={r.id} className="text-xs bg-emerald-100 text-emerald-800 rounded-full px-2 py-0.5">{r.nom}</span>)}</div></div>
          <Button data-testid="nouveau-creer-btn" className="w-full rounded-full bg-emerald-700 hover:bg-emerald-800" disabled={!f.titre} onClick={creer}>Ajouter au planning</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
